module.exports = __webpack_public_path__ + "img/fafangzhong.2e95ce81.svg";